<div class="list-cell-creator">
  <span class="list-cell-creator-title no-select" (click)="onCreatorClick.emit()">{{ name }}</span>
  <span class="list-cell-creator-date">{{ created | dateFormat }}</span>
</div>

